import { render, staticRenderFns } from "./ReturnProcessMaterial.vue?vue&type=template&id=37b45700&scoped=true"
import script from "./ReturnProcessMaterial.vue?vue&type=script&lang=js"
export * from "./ReturnProcessMaterial.vue?vue&type=script&lang=js"
import style0 from "./ReturnProcessMaterial.vue?vue&type=style&index=0&id=37b45700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b45700",
  null
  
)

export default component.exports